import { configureStore } from "@reduxjs/toolkit"

import { authReducer } from "./slices/auth.slice"
import { billerGroupsReducer } from "./slices/billerGroups.slice"
import { checkerReducer } from "./slices/checker.slice"
import { coverageOverridesReducer } from "./slices/coverageOverrides.slice"
import { coveragePayersReducer } from "./slices/coveragePayers.slice"
import { networkStatusReducer } from "./slices/networkStatus.slice"
import { organizationReducer } from "./slices/organization.slice"
import { policiesReducer } from "./slices/policies.slice"
import { reportSavedFiltersReducer } from "./slices/reportSavedFilters.slice"
import { runtimeReducer } from "./slices/runtime.slice"
import { supportReducer } from "./slices/support.slice"
import { userDetailsReducer } from "./slices/userDetails.slice"

export const store = configureStore({
    reducer: {
        auth: authReducer,
        runtime: runtimeReducer,
        userDetails: userDetailsReducer,
        checker: checkerReducer,
        organization: organizationReducer,
        coveragePayers: coveragePayersReducer,
        billerGroups: billerGroupsReducer,
        policies: policiesReducer,
        reportSavedFilters: reportSavedFiltersReducer,
        coverageOverrides: coverageOverridesReducer,
        support: supportReducer,
        networkStatus: networkStatusReducer,
    },
    // Ignore serialization warnings
    // Since for example toastr puts them in store
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
})

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch
